import styled, { keyframes } from 'styled-components';

const spin = keyframes`
  to {
    transform: rotate(360deg);
  }
`;

export const PageLoader = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 0.85rem;
  width: 100%;
  min-height: 16rem;
  padding: 2rem 1rem;
`;

export const Overlay = styled.div`
  position: fixed;
  inset: 0;
  z-index: 9999;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 0.85rem;
  background: ${({ theme }) => theme.modalBackground ?? 'rgba(15, 18, 28, 0.35)'};
  backdrop-filter: blur(3px);
  -webkit-backdrop-filter: blur(3px);
`;

export const Spinner = styled.div<{ $size: number }>`
  width: ${({ $size }) => $size}px;
  height: ${({ $size }) => $size}px;
  border-radius: 50%;
  border: ${({ $size }) => Math.max(2, Math.round($size * 0.08))}px solid
    ${({ theme }) => theme.lightGrey};
  border-top-color: ${({ theme }) => theme.primary};
  animation: ${spin} 0.7s linear infinite;
  flex-shrink: 0;
`;

export const LoaderLabel = styled.span`
  font-size: 0.8125rem;
  font-weight: 500;
  color: ${({ theme }) => theme.midGrey};
`;
